(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["CollectionSlider"]) return;
  try {
    
$( document ).ready(function() {


    $('.collection-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<div class="prev_slick_col"></div>',
        nextArrow: '<div class="next_slick_col"></div>',
        focusOnSelect: false,
        animOn: true, 
        easing: 'easeOutExpo',
        lazyLoad: 'ondemand',
        touchThreshold: 12,
         responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 374,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-slider"] && !window.DesignMode) return;
  try {
    

$( document ).ready(function() {

    $('.featured-content-slider').slick({
      slidesToShow: 3,
	  arrows: false,
	  responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

	$(document).on('click', '.feat-prev', function(e) { 
        $('.featured-content-slider').slick('slickPrev');
    });

	$(document).on('click', '.feat-next', function(e) { 
        $('.featured-content-slider').slick('slickNext');
    });

});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["GiftGuideLPReviews"]) return;
  try {
      



$( document ).ready(function() {

    $('.ggLp-revs-slider').slick({
      slidesToShow: 1,
	  arrows: true,
      prevArrow: '<div class="gglp-arrow gglp-arrowprev"><img src="https://cdn.shopify.com/s/files/1/0814/0539/files/Left_Arrow_6d903ef4-8bb2-4e47-a7dd-1cfae154047a.svg"/></div>',
      nextArrow: '<div class="gglp-arrow gglp-arrownext"><img src="https://cdn.shopify.com/s/files/1/0814/0539/files/Right_Arrow_5fa2d995-0b5f-4c05-b1d8-d834a564d905.svg"/></div>'		
    });


});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews-slider"] && !window.DesignMode) return;
  try {
      



$( document ).ready(function() {
    $('.home-revs-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){    
	  /*let initial_height = 522;
	  let current_height = $(".home-revs-slide.slick-active").height();
 	  let current_bottom_position = $(".home-revs-controls").css("bottom");
	  current_bottom_position = parseInt(current_bottom_position.replace("px",""));
	  let new_bottom_position = (initial_height - current_height)*1;  
	  if(new_bottom_position == 0){
	  	$(".home-revs-controls").css("bottom","70px");
	  }else{ 
	  	$(".home-revs-controls").css("bottom",current_bottom_position+new_bottom_position);
	  }*/
    });
    $('.home-revs-slider').slick({
      slidesToShow: 1,
	  arrows: false,
	  asNavFor: '.home-revs-slider-products'
    });

	$(document).on('click', '.hrevprev', function(e) { 
        $('.home-revs-slider').slick('slickPrev');
    });

	$(document).on('click', '.hrevnext', function(e) { 
        $('.home-revs-slider').slick('slickNext');
    });
    $(document).on('click', '.home-revs-slider-products-wrapper', function(e) {
		debugger; 
		if(this == e.target){
			window.location.href = $(this).find(".slick-active a").attr("href");
		} 
	})
	$('.home-revs-slider-products').slick({
      slidesToShow: 1,
	  arrows: false,
	  asNavFor: '.home-revs-slider',
      fade: true,
	  speed: 600
    }); 

	$('.home-revs-mob-images').slick({
      slidesToShow: 1,
	  arrows: false,
	  asNavFor: '.home-revs-slider',
	  dots: true
    });

});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["PopUpVideo"]) return;
  try {
    
$( document ).ready(function() {

    $(".wvideo").colorbox({
      iframe: true,
      innerWidth: 960,
      innerHeight: 540,
      maxWidth: '95%',
      maxHeight: '95%',
      top: '3%',
      closeButton: 'true',
      className: 'gallerybox'
  	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ReadMoreText"]) return;
  try {
    
$( document ).ready(function() {

    $(document).on('click', '.aa-txttrun', function(e) {
          e.preventDefault();
          var Par = $(this).closest('.aa-stone');

          if($(this).html() == "READ MORE"){
            Par.find('.aa-txttrun').addClass('aa-txttrunless');
            Par.find('.aa-txttrun').html('READ LESS').insertAfter($(this).next());
            Par.find('p span').fadeIn(300);
            Par.find('p').removeClass('aa-txtshort').addClass('aa-txtlarge');
          } else {
            Par.find('.aa-txttrun').removeClass('aa-txttrunless');            
            Par.find('p span').fadeOut(300, function() {
                Par.find('.aa-txttrun').html('READ MORE').insertBefore($(this).prev());
            });
            Par.find('p').addClass('aa-txtshort').removeClass('aa-txtlarge');
          }

    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RegistrationContent"]) return;
  try {
    

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};
  
$( document ).ready(function() {

    var coll = getUrlParameter('collection');
  
  	$('.rcontent[data-collection*="'+coll+'"]').fadeIn();
                                         
    var whandle = getUrlParameter('handle');
                                         
	$.ajax({ 
            url: '/products/' + whandle + '.js', 
            dataType: 'json',
            async: false, 
            success: function(product){ 

              product.tags.forEach(function(prodtag) {
                if ( warranty_list[prodtag] != undefined ){
                    has_exwarranty = true;  
                    warranty_plan = warranty_list[prodtag].varid;
                  	warranty_planprice = warranty_list[prodtag].price;
                    $('.exwaritem').addClass('buynow').attr('data-variant-id',warranty_plan);
                }
              });          

            }
          });  
                                         
                                         	
                                         
});
                       
                          
                 
                                         
                                         

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SliderVerticalPhotos"]) return;
  try {
    

$( document ).ready(function() {

	$('.ver-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: '<img class="verprev" src="https://cdn.shopify.com/s/files/1/0814/0539/files/vanarr.png"/>',
      nextArrow: '<img class="vernext" src="https://cdn.shopify.com/s/files/1/0814/0539/files/vanarr2.png"/>',
      responsive: [
         {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["TopHeaderTextSlider"]) return;
  try {
    
$( document ).ready(function() {

function generateTimer() {

	var customdate = $( ".CountdownTimer" ).parent().parent().data('datetimer');

	if (customdate) {
    	var countdownDate =  moment.tz(customdate,'US/Pacific');
		
    }
	else {

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();
        if(mm<10) {
                  mm = '0'+mm
                  } 
                  if(dd<10) {
        dd = '0'+dd
        } 
        var ct_date = yyyy+"-"+mm+"-"+dd+" 23:59";
        //var ct_date = "2018-09-01 23:59";

        var countdownDate =  moment.tz(ct_date,'US/Pacific'); 

    }
                          
  	$('.top-timer').countdown(countdownDate.toDate(), function(event) {

    
    var me = $(this);

	  var hideDays = false;
      var dbf = event.offset.totalDays;
		
      var hbf = event.offset.hours; //event.offset.days * 24 + event.offset.hours; /// event.offset.days

	  if (dbf==0){
		 hideDays = true;  
	  }
	  else {
		if(hbf > 4){
			dbf = dbf + 1;	
		}
	  }


      dbf = dbf.toString();
      if (dbf.toString().length == 1){
        dbf = dbf;
      }
      
      
       
      hbf = hbf.toString();
      if (hbf.toString().length == 1){
        hbf = '0'+hbf;
      }
      
      var mbf = event.offset.minutes.toString();
      if (mbf.toString().length == 1){
        mbf = '0'+mbf;
      }
    
      var sbf = event.offset.seconds.toString();
      if (sbf.toString().length == 1){
        sbf = '0'+sbf;
      }  
      
      me.find('.daystop').text(dbf);
      me.find('.hourstop').text(hbf);
      me.find('.minutestop').text(mbf);
      me.find('.secondstop').text(sbf);
    
	  if(hideDays){
		$( ".CountdownTimer .num_container_days" ).hide();
	  }
      else {
		$( ".CountdownTimer .num_container_time" ).hide();
	  }
     
  	}).on('finish.countdown', function(){


  	});
  
}
    

    
    if ( $( ".CountdownTimer" ).length ) { 

		$( ".CountdownTimer" ).each(function( index ) {

            $( this ).html('<div class="top-timer">\
              <span class="clock-text"></span>\
              <div class="num_container num_container_days">\
              <span class="time-circletop daystop"></span><span class="xtime xtimedays">Days</span><span class="semicolon"></span>\
              </div>\
              <div class="num_container num_container_time">\
              <span class="time-circletop hourstop"></span><span class="xtime">HRS</span><span class="semicolon"></span>\
              </div>\
              <div class="num_container_sep num_container_time">:</div>\
              <div class="num_container num_container_time">\
              <span class="time-circletop minutestop"></span><span class="xtime">MINS</span><span class="semicolon"></span>\
              </div>\
              <div class="num_container_sep num_container_time">:</div>\
              <div class="num_container num_container_time">\
                <span class="time-circletop secondstop"></span><span class="xtime">SEC</span>\
              </div>\
            </div>'); 


          generateTimer();

        });


       

    }

});






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["WoodshopContent"]) return;
  try {
    
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):a(jQuery)}(function(a){"use strict";function b(a){if(a instanceof Date)return a;if(String(a).match(g))return String(a).match(/^[0-9]*$/)&&(a=Number(a)),String(a).match(/\-/)&&(a=String(a).replace(/\-/g,"/")),new Date(a);throw new Error("Couldn't cast `"+a+"` to a date object.")}function c(a){var b=a.toString().replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");return new RegExp(b)}function d(a){return function(b){var d=b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);if(d)for(var f=0,g=d.length;g>f;++f){var h=d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),j=c(h[0]),k=h[1]||"",l=h[3]||"",m=null;h=h[2],i.hasOwnProperty(h)&&(m=i[h],m=Number(a[m])),null!==m&&("!"===k&&(m=e(l,m)),""===k&&10>m&&(m="0"+m.toString()),b=b.replace(j,m.toString()))}return b=b.replace(/%%/,"%")}}function e(a,b){var c="s",d="";return a&&(a=a.replace(/(:|;|\s)/gi,"").split(/\,/),1===a.length?c=a[0]:(d=a[0],c=a[1])),1===Math.abs(b)?d:c}var f=[],g=[],h={precision:100,elapse:!1};g.push(/^[0-9]*$/.source),g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),g=new RegExp(g.join("|"));var i={Y:"years",m:"months",n:"daysToMonth",w:"weeks",d:"daysToWeek",D:"totalDays",H:"hours",M:"minutes",S:"seconds"},j=function(b,c,d){this.el=b,this.$el=a(b),this.interval=null,this.offset={},this.options=a.extend({},h),this.instanceNumber=f.length,f.push(this),this.$el.data("countdown-instance",this.instanceNumber),d&&("function"==typeof d?(this.$el.on("update.countdown",d),this.$el.on("stoped.countdown",d),this.$el.on("finish.countdown",d)):this.options=a.extend({},h,d)),this.setFinalDate(c),this.start()};a.extend(j.prototype,{start:function(){null!==this.interval&&clearInterval(this.interval);var a=this;this.update(),this.interval=setInterval(function(){a.update.call(a)},this.options.precision)},stop:function(){clearInterval(this.interval),this.interval=null,this.dispatchEvent("stoped")},toggle:function(){this.interval?this.stop():this.start()},pause:function(){this.stop()},resume:function(){this.start()},remove:function(){this.stop.call(this),f[this.instanceNumber]=null,delete this.$el.data().countdownInstance},setFinalDate:function(a){this.finalDate=b(a)},update:function(){if(0===this.$el.closest("html").length)return void this.remove();var b,c=void 0!==a._data(this.el,"events"),d=new Date;b=this.finalDate.getTime()-d.getTime(),b=Math.ceil(b/1e3),b=!this.options.elapse&&0>b?0:Math.abs(b),this.totalSecsLeft!==b&&c&&(this.totalSecsLeft=b,this.elapsed=d>=this.finalDate,this.offset={seconds:this.totalSecsLeft%60,minutes:Math.floor(this.totalSecsLeft/60)%60,hours:Math.floor(this.totalSecsLeft/60/60)%24,days:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToWeek:Math.floor(this.totalSecsLeft/60/60/24)%7,daysToMonth:Math.floor(this.totalSecsLeft/60/60/24%30.4368),totalDays:Math.floor(this.totalSecsLeft/60/60/24),weeks:Math.floor(this.totalSecsLeft/60/60/24/7),months:Math.floor(this.totalSecsLeft/60/60/24/30.4368),years:Math.abs(this.finalDate.getFullYear()-d.getFullYear())},this.options.elapse||0!==this.totalSecsLeft?this.dispatchEvent("update"):(this.stop(),this.dispatchEvent("finish")))},dispatchEvent:function(b){var c=a.Event(b+".countdown");c.finalDate=this.finalDate,c.elapsed=this.elapsed,c.offset=a.extend({},this.offset),c.strftime=d(this.offset),this.$el.trigger(c)}}),a.fn.countdown=function(){var b=Array.prototype.slice.call(arguments,0);return this.each(function(){var c=a(this).data("countdown-instance");if(void 0!==c){var d=f[c],e=b[0];j.prototype.hasOwnProperty(e)?d[e].apply(d,b.slice(1)):null===String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)?(d.setFinalDate.call(d,e),d.start()):a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi,e))}else new j(this,b[0],b[1])})}});



function generateDiscTIMER() {


	$( ".wshop-timer .discount-timerbf" ).each(function( index ) {

	var datatimeat = $(this).attr('data-datetime');
    var countdownDate =  moment.tz(datatimeat,'US/Pacific');
  


    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0!
    var yyyy = today.getFullYear();
    if(mm<10) {
      mm = '0'+mm
    } 
    if(dd<10) {
      dd = '0'+dd
    } 
      var ct_date = yyyy+"-"+mm+"-"+dd+" 23:59";
      //var ct_date = "2018-09-01 23:59";

      //var countdownDate =  moment.tz(ct_date,'US/Pacific');  

                          
  	$(this).countdown(countdownDate.toDate(), function(event) {

    
    var me = $(this);

      var dbf = event.offset.totalDays;
      dbf = dbf.toString();
      if (dbf.toString().length == 1){
        dbf = '0'+dbf;
      }
      
      
      var hbf = event.offset.hours; //event.offset.days * 24 + event.offset.hours; /// event.offset.days
      hbf = hbf.toString();
      if (hbf.toString().length == 1){
        hbf = '0'+hbf;
      }

	  var totalHours = event.offset.days * 24 + event.offset.hours;
      
      var mbf = event.offset.minutes.toString();
      if (mbf.toString().length == 1){
        mbf = '0'+mbf;
      }
    
      var sbf = event.offset.seconds.toString();
      if (sbf.toString().length == 1){
        sbf = '0'+sbf;
      }  
      
      me.find('.daysbf').text(dbf);
      me.find('.hoursbf').text(hbf);
      me.find('.minutesbf').text(mbf);
      me.find('.secondsbf').text(sbf);
	  me.parent().parent().parent().find('.number').text(totalHours);
      //me.parent().parent().parent().append('<p class="number" style="display:none">'+ totalHours + '</p>');

     

  	}).on('finish.countdown', function(){

	});

  	});
  
}

$( document ).ready(function() {

     generateDiscTIMER();


    $.fn.isOnScreen = function() {
    var win = $(window);
    var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    $(window).scroll(function() {


	$( ".wshop-bar" ).each(function( index ) {

  		console.log( index + ": " + $( this ).text() );
          if ($( this ).isOnScreen()) {
            $( this ).addClass('wshop-baron');
          } else {
          	$( this ).removeClass('wshop-baron');
          }
	});

    });


	$(".danvideo").colorbox({
      iframe: true,
      innerWidth: 960,
      innerHeight: 540,
      maxWidth: '95%',
      maxHeight: '95%',
           top: '3%',
      closeButton: 'true',
      className: 'gallerybox'
  	});



});






  } catch(e) { console.error(e); }
})();

})();
